<template>
  <div class="transform-child-component-main w-64">
      <div class="pbc-component-type-header">
        <div class="pbc-component-type-icon-parent">
          <radio-tower :size='16' class="pbc-component-type-icon" />
        </div>
        <div class="pbc-component-type-name">event</div>
      </div>

      <div class="transform-child-component-summary grow">
        <events-selector v-if='transform.vars' class="w-full" v-model='transform.vars.eventName' :events-list='eventsList'  />
      </div>


    </div>

</template>
<script>
import RadioTower from '@icons/RadioTower.vue';
import Searcher from '@edit/tree/searcher.js';
import EventsSelector from '@ui/atoms/EventsSelector.vue';
export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      required:true
    },
    transformsAndSource:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    }
  },
  data() {
    console.log('TRANSFORM', this.transform);
    const searcher = new Searcher(this.transformsAndSource.gamedata);
    const component = this.partutil.findComponentForTransform(this.parentTransform);
    const eventsList = searcher.findEvents();
    return {
      eventsList,
      component,
    }
  },
  components:{
    EventsSelector,
    RadioTower
  },
  methods:{
    onChange(in_nv, in_ov) {
      const type = 'vars';
      const nv = {
        delay: in_nv
      }
      const ov = {
        delay: in_ov
      }
      this.$emit("change", {
          nv,
          ov,
          type
      });
    }
  }
}
</script>
